import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

const getComponentForType = (type) => {
  switch (type) {
    case 'error':
      return Error;
    case 'openings':
      return OpeningsText;
    default:
      throw new Error('Unknown text type');
  }
};

export default observer(({ type, children }) => {
  let Component = getComponentForType(type);
  return <Component>{children}</Component>;
});

const Error = styled.span`
  color: ${(p) => p.theme.errorColor};
  font-size: 12px;
`;

const OpeningsText = styled.span`
  color: ${(p) => p.theme.primaryColor};
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
`;
